import * as types from './globalUI.actionTypes';

export const setPlans = (plans) => ({
  type: types.SET_PLANS,
  payload: {
    plans,
  }
});

export const setLoading = (loading?: boolean) => ({
  type: types.SET_LOADING,
  payload: {
    loading,
  },
})

export const setYearlyPlan = plan => ({
  type: types.SET_YEARLY_PLAN,
  payload: { plan }
})